import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EpagoService } from 'src/app/services/epago.service';
import { v4 as uuidv4 } from 'uuid';
import { ScriptService } from 'src/app/services/script.service';
import { CHECKOUT2_PAYMENT_METHOD_GROUPS } from 'src/app/config/payment-methods.config';

declare const Epago: any;
declare const sha512: any;

@Component({ standalone: false,
  selector: 'app-form-checkout2',
  templateUrl: './form-checkout2.component.html',
  styleUrls: ['./form-checkout2.component.css']
})
export class FormCheckout2Component implements OnInit, OnDestroy {
  @ViewChild("paymentOverlay", { static: true }) paymentOverlay: ElementRef | undefined;
  paymentOverlayOpen = false;
  /** Mientras se descarga el script del SDK (modal). */
  paymentSdkLoading = false;
  @ViewChild("cartContainer", { static: true }) cartContainer: ElementRef | undefined;
  @ViewChild("cartContainer2", { static: true }) cartContainer2: ElementRef | undefined;

  orderIdInterval: any;
  paymentMethodGroups = CHECKOUT2_PAYMENT_METHOD_GROUPS;
  myForm: FormGroup;
  minicartItems: FormGroup;
  items: any = [{ "name": "Heladera", "quantity": 1, "unitAmount": 10, "amount": 10, "sku": "1234567890", "category": "Electrodoméstico", "discount": 0, "shipping": 0 }];

  /** Instancia activa del SDK en modal / embebido (para poder cerrar tras iniciar pago). */
  private epagoFormInstance: { unmount?: () => void; destroy?: () => void; close?: () => void } | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private epagoService: EpagoService,
    private renderer: Renderer2,
    private scriptService: ScriptService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {
    let autoOrderId = this.generateOrderId();
    this.myForm = this.formBuilder.group({
      'env': ['QAV1'],
      'api': ['generico'],
      'merchantName': ['OTRO'],
      // 'merchantKey': ['c5da785c644f4133aed96fdb17d039af'],
      'merchantKey': ['OCC-40467ba5-f254-4cf0-937e-9f42a206cb3f'],
      // 'merchantToken': ['35f3e4ff91d648d43b274eb70a6a6c829e656f566a1a74'],
      'merchantToken': ['93ffbb5b3e574d76a89b43ded9daa0e4'],
      'otherMerchantName': ['irdcomercio'],
      'paymentMethod': ['AGORAWEB'],
      'brands': ['AGORAWEB'],
      'versionSdk': ['v1'],
      'modeSdk': [''],
      'orderId': [autoOrderId],
      'quantity': [1],
      'sku': ['1020304005060'],
      'reference': uuidv4(),
      'transactionId': uuidv4(),
      'paymentId': 'vtx-sim-' + this.makeid(17),
      'currency': ['PEN'],
      'amount': [10.10],
      'discounts': [0],
      'shipping': [0],
      // 'taxes': [0],
      'fee': [0],
      'email': ['test@test.com'],
      'name': ['Jhony'],
      'lastname': ['Pacheco'],
      'phone': ['998910021'],
      'identifier': ['sergio441'],
      'documentNumber': ['98910021'],
      'address1': ['Av Zeta 1'],
      'installments': [1],
      'deviceFingerprint': ['12ade389087fe'],
      'callerUrl': [window.location.href],
      'callbackUrl': ['', Validators.required],
      'returnUrl': [this.getCallBack(autoOrderId)],
      'signedElement': [''],
      'payWithQr': [false],
      'metadataName': [''],
      'metadataValue': [''],
      'metadata': this.formBuilder.array([]),
    });

    this.minicartItems = this.formBuilder.group({
      "name": ['Heladera'],
      "quantity": [1],
      "unitAmount": [10],
      "amount": [10],
      "sku": ['1234567890'],
      "category": ['Electrodoméstico'],
      "discount": [0],
      "shipping": [0]
    })

    this.myForm.get('amount')?.setValue(this.calculateTotal())

  }

  getCallBack(orderId: string): string {
    return window.location.protocol + '//' + window.location.host + '/return?orderId=' + orderId;
  }

  private toPositiveNumber(value: any): number {
    return Math.abs(Number(value) || 0);
  }

  private buildNormalizedProducts(): any[] {
    return this.items.map((item: any) => {
      const quantity = Number(item.quantity) || 0;
      const unitAmount = Number(item.unitAmount) || 0;
      const grossAmount = unitAmount * quantity;
      const discount = this.toPositiveNumber(item.discount);

      return {
        ...item,
        quantity,
        unitAmount,
        amount: grossAmount,
        discount,
        shipping: Number(item.shipping) || 0
      };
    });
  }

  calculateTotal(): number {
    const normalizedProducts = this.buildNormalizedProducts();
    const productsTotal = normalizedProducts.reduce((amount: number, current: any) => {
      return amount + (current.amount - current.discount + current.shipping);
    }, 0);

    const discountValue = this.myForm.get('discounts')?.value;
    const discount = this.toPositiveNumber(discountValue);
    const shipping = Number(this.myForm.get('shipping')?.value);
    //const taxes =  Number(this.myForm.get('taxes')?.value);
    const fee = Number(this.myForm.get('fee')?.value);

    return productsTotal - discount + shipping + fee;
  }

  ngOnInit(): void {
    this.myForm.get("orderId")?.valueChanges.subscribe(selectedValue => {
      this.myForm.get('returnUrl')?.setValue(this.getCallBack(selectedValue));
    })

    // Actualizar el orderId cada segundo
    this.orderIdInterval = setInterval(() => {
      const newOrderId = this.generateOrderId();
      this.myForm.get('orderId')?.setValue(newOrderId, { emitEvent: true });
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.orderIdInterval) {
      clearInterval(this.orderIdInterval);
    }
    this.closePaymentWindow();
  }

  generateOrderId(): string {
    // Generar orderId basado en segundos (en lugar de milisegundos)
    const secondsTimestamp = Math.floor(Date.now() / 1000);
    return '' + secondsTimestamp;
  }

  changeEnvironment(event: any) {
  }

  changeApi(event: any) {
  }

  changePaymentMethod(event: any) {
    console.log('change paymentMethod', event);
  }

  get metadataFields(): FormArray {
    return this.myForm.get('metadata') as FormArray;
  }

  /** Pares name/value de order.metadata. Nombre vacío no se agrega; un nombre repetido actualiza el valor. */
  addMetadataField(): void {
    const name = String(this.myForm.get('metadataName')?.value ?? '').trim();
    const value = String(this.myForm.get('metadataValue')?.value ?? '').trim();
    if (!name) {
      return;
    }

    const existing = this.metadataFields.controls.find(
      (control) => String(control.get('name')?.value ?? '').trim() === name
    );
    if (existing) {
      existing.get('value')?.setValue(value);
    } else {
      this.metadataFields.push(this.formBuilder.group({
        name: [name],
        value: [value],
      }));
    }

    this.myForm.get('metadataName')?.setValue('');
    this.myForm.get('metadataValue')?.setValue('');
  }

  /** Mismo campo que PayLink envía en order.metadata al simular origen link. */
  addCreatedFromLinkMetadata(): void {
    this.myForm.get('metadataName')?.setValue('createdFromLink');
    this.myForm.get('metadataValue')?.setValue('true');
    this.addMetadataField();
  }

  removeMetadataField(index: number): void {
    this.metadataFields.removeAt(index);
  }

  buildOrderMetadata(): Array<{ name: string; value: string }> {
    return this.metadataFields.controls
      .map((control) => ({
        name: String(control.get('name')?.value ?? '').trim(),
        value: String(control.get('value')?.value ?? ''),
      }))
      .filter((entry) => entry.name.length > 0);
  }

  buildOrderMinimalData(): any {
    const discountValue = this.myForm.get('discounts')?.value;
    const normalizedProducts = this.buildNormalizedProducts();
    const orderLevelDiscount = this.toPositiveNumber(discountValue);
    const metadata = this.buildOrderMetadata();

    return {
      "order": {
        "number": this.myForm.get('orderId')?.value,
        "amount": this.calculateTotal(),
        "fee": Number(this.myForm.get('fee')?.value),
        "taxes": 0,
        "discounts": orderLevelDiscount,
        "shippingAmount": Number(this.myForm.get('shipping')?.value),
        "country": {
          "code": "PER"
        },
        "currency": {
          "code": this.myForm.get('currency')?.value
        },
        "products": normalizedProducts,
        "customer": {
          "identifier": this.myForm.get('identifier')?.value,
          "name": this.myForm.get('name')?.value,
          "lastName": this.myForm.get('lastname')?.value,
          "address": {
            "country": "PER",
            "levels": [
              "LIMA",
              "LIMA",
              "SAN ISIDRO"
            ],
            "line1": this.myForm.get('address1')?.value,
            "zip": "051014"
          },
          "email": this.myForm.get('email')?.value,
          "phone": this.myForm.get('phone')?.value,
          "document": {
            "type": "DNI",
            "number": this.myForm.get('documentNumber')?.value
          }
        },
        ...(metadata.length > 0 ? { metadata } : {}),
      },
      "settings": {
        "paymentMethods": [this.myForm.get('paymentMethod')?.value],
        "brands": this.myForm.get('paymentMethod')?.value == 'AGORAWEB' ? ['AGORAWEB'] : ['VISA', 'MSCD', 'AMEX', 'DINC'],
        "language": "es_PE",
        "businessService": "WEB",
      }
    };
  }

  generatePayment(htmlDiv: string) {
    const env = this.myForm.get('env')?.value;
    const isModal = htmlDiv === '#cart-container';
    if (isModal) {
      this.paymentSdkLoading = true;
      this.paymentOverlayOpen = true;
      this.cdr.detectChanges();
    }
    const script = this.scriptService.loadJsScript(this.renderer, env);
    script.onload = () => {
      this.ngZone.run(() => {
        this.startPayment(htmlDiv, env);
        this.paymentSdkLoading = false;
        this.cdr.detectChanges();
      });
    };
    script.onerror = () => {
      this.ngZone.run(() => {
        this.paymentSdkLoading = false;
        if (isModal) {
          this.paymentOverlayOpen = false;
        }
        this.cdr.detectChanges();
        console.error('No se pudo cargar el SDK de Epago');
      });
    };
  }

  /** Render del SDK cuando el contenedor modal ya tiene layout visible (evita iframe en blanco). */
  private renderEpagoFormWhenVisible(form: { render: (selector: string) => void }, selector: string): void {
    requestAnimationFrame(() => {
      form.render(selector);
      this.cdr.detectChanges();
    });
  }

  private executeNoFormPayment(form: any, containerSelector: string, payment: any): void {
    const candidates = [
      'perform_pay_app_noform',
      'performPayAppNoForm',
      'performPayNoForm',
      'performPay'
    ];

    for (const methodName of candidates) {
      const method = form?.[methodName];
      if (typeof method === 'function') {
        method.call(form, containerSelector, payment);
        return;
      }
    }

    const globalCandidates = [
      'perform_pay_app_noform',
      'performPayAppNoForm',
      'performPayNoForm',
      'performPay'
    ];

    for (const methodName of globalCandidates) {
      const method = (Epago as any)?.[methodName];
      if (typeof method === 'function') {
        method(containerSelector, payment, form);
        return;
      }
    }

    const formMethods = Object.keys(form || {}).filter((key: string) => typeof form?.[key] === 'function');
    throw new Error(
      `El SDK cargado no expone método de pago sin formulario. Métodos encontrados en Form: ${formMethods.join(', ') || 'ninguno'}`
    );
  }

  startPayment(htmlDiv: string, env: string) {
    let module = this.myForm.get('api')?.value;

    switch (module) {
      case 'generico':

        this.renderer.setProperty(this.cartContainer?.nativeElement, 'innerHTML', "");
        this.renderer.setProperty(this.cartContainer2?.nativeElement, 'innerHTML', "");


        // var signatureKey = merchantToken;
        var signatureKey = this.myForm.get('merchantToken')?.value;
        var versionSdk = this.myForm.get('versionSdk')?.value;
        var modeSdk = this.myForm.get('modeSdk')?.value;
        // var identifier = merchantKey;
        var identifier = this.myForm.get('merchantKey')?.value;

        var orderMinimalData = this.buildOrderMinimalData();
        var signedElement = this.myForm.get('signedElement')?.value;
        var signature = this.generateSignature(identifier, orderMinimalData, signatureKey, signedElement);

        var autheticationData = {
          identifier: identifier,
          signature: signature,
          signedElement: signedElement
        } as any;
        console.log('autheticationData', autheticationData);

        // configuracion del sdk
        let environmentValue = 'production';
        if (env === 'QAnL&F' || env === 'QAV1' || env === 'PROD/QA' || env === 'SDK_VERSION_OLD' || env === 'REACT_SDK') {
          environmentValue = 'quality';
        } else if (env === 'PRODCORD') {
          environmentValue = 'production';
        } else if (env === 'DEV' || env === 'REACT_SDK_DEV') {
          environmentValue = 'development';
        }

        const epagoFormConfig: any = {
          authentication: autheticationData,
          transaction: orderMinimalData,
          environment: environmentValue,
          version: versionSdk,
          listeners: {
            afterPay: (response: any) => {
              console.info({ ecommerceCapureResponse: response });
              this.ngZone.run(() => {
                this.closePaymentWindow();
                this.cdr.detectChanges();
              });
            },
            paymentStarting: function (response: any) {
              console.log('[form-checkout2] paymentStarting', response);
              console.log('[form-checkout2] paymentStarting.startPayAt', response && response.startPayAt);
            },
            afterClickOnPay: function () {
              console.info('afterClickOnPay iniciado correctamente');
            }
          },
          ...(modeSdk && { mode: modeSdk }),
          ...(this.myForm.get('payWithQr')?.value === true && { qrPayment: true }),
        };

        console.log('epagoFormConfig', epagoFormConfig);

        this.teardownEpagoForm();
        var form = new Epago.Form(epagoFormConfig);
        this.epagoFormInstance = form;

        if (htmlDiv === '#cart-container') {
          this.renderEpagoFormWhenVisible(form, htmlDiv);
        } else if (htmlDiv === '#cart-container-2') {
          form.render(htmlDiv);
        }
        else {
          var payment = {
            "paymentMethod": this.myForm.get('paymentMethod')?.value,
            "cardholder": {
              "phone": this.myForm.get('phone')?.value,
              "document": {
                "type": "DNI",
                "number": this.myForm.get('documentNumber')?.value
              }
            }
          };
          this.executeNoFormPayment(form, '#cart-container-3', payment);
        }

        break;

      default:
        break;
    }
  }

  closePaymentWindow() {
    this.paymentOverlayOpen = false;
    this.paymentSdkLoading = false;
    try {
      this.teardownEpagoForm();
    } catch {
      /* el SDK puede fallar al desmontar; igual cerramos el overlay */
    }
    try {
      this.clearEpagoContainer(this.cartContainer);
    } catch {
      /* noop */
    }
  }

  private teardownEpagoForm(): void {
    const form = this.epagoFormInstance;
    if (form) {
      for (const method of ['unmount', 'destroy', 'close'] as const) {
        const fn = form[method];
        if (typeof fn === 'function') {
          try {
            fn.call(form);
          } catch {
            /* noop */
          }
          break;
        }
      }
    }
    this.epagoFormInstance = null;
  }

  private clearEpagoContainer(el: ElementRef | undefined): void {
    if (el?.nativeElement) {
      this.renderer.setProperty(el.nativeElement, 'innerHTML', '');
    }
  }

  generateSignature(identifier: any, orderData: any, signatureKey: any, signedElement: any) {

    var orderNumber = orderData.order.number,
      amount = orderData.order.amount,
      currencyCode = orderData.order.currency.code;
    var signatureBase = '';
    if (signedElement) {
      signatureBase = identifier + signedElement + signatureKey;
    } else {
      signatureBase = identifier + orderNumber + currencyCode + amount + signatureKey;
    }
    var signature = sha512(signatureBase);
    return signature;
  }

  makeid(length: number) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  newMinicartItem(): any {
    const discountValue = this.minicartItems.get('discount')?.value;

    return {
      name: this.minicartItems.get('name')?.value,
      quantity: this.minicartItems.get('quantity')?.value,
      unitAmount: +this.minicartItems.get('amount')?.value,
      amount: (+this.minicartItems.get('amount')?.value) * this.minicartItems.get('quantity')?.value,
      sku: this.minicartItems.get('sku')?.value,
      category: this.minicartItems.get('category')?.value,
      discount: this.toPositiveNumber(discountValue),
      shipping: Number(this.minicartItems.get('shipping')?.value)
    }
  }

  addMinicartItem() {
    this.items.push(this.newMinicartItem());
    console.log(this.items)
  }

  removeMinicartItem(i: number) {
    this.items.splice(i, 1)
  }

  copyOrderId(): void {
    const id = this.myForm.get('orderId')?.value;
    if (id == null || id === '') {
      return;
    }
    navigator.clipboard?.writeText(String(id)).catch(() => undefined);
  }

}
